<template>
    <div class="m_container">
        <Header :title="tougaoInfo.title" show-left />
        <section class="m_section">
            <div class="content">
                <h1>{{ detail.title }}</h1>
                <p v-html="detail.content" />
            </div>
        </section>
        <TabBar :current-tab="currentTab" />
    </div>
</template>

<script>
import Header from '@/components/Header/index'
import TabBar from '@/components/TabBar/index'
import { mapGetters } from 'vuex'
import { noticeDetail } from '@/api/notice'

export default {
    name: 'MessageDetail',
    components: { Header, TabBar },
    data() {
        return {
            currentTab: 'message',
            loading: false,
            id: this.$route.query.id,
            detail: {}
        }
    },

    computed: {
        ...mapGetters(['tougaoInfo', 'setting'])
    },

    created() {
        this.getDetail()
    },

    methods: {
        getDetail() {
            this.loading = true
            noticeDetail({ id: this.id }).then(res => {
                this.loading = false
                if (res.code === 200) {
                    this.detail = res.data.info
                }
            }).catch(() => { this.loading = false })
        }
    }
}
</script>

<style lang="less" scoped>
.m_container{
  width: 100%;
  height: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #FFFFFF;

  .m_section {
    flex:1;
    padding-bottom: 100px;

    h1{
      padding:20px 0;
      text-align: center;
      font-size: 19px;
      font-weight: 600;
    }
    .content{
      text-align: left;
      padding: 0 15px 10px;
      word-break: break-word;
      white-space: normal;
      p {
        text-indent: 16px;
        text-align: left;
        line-height: 28px;
        font-size: 14px;
      }
    }
  }
}
</style>
